<template>
    <div class="expande-horizontal wrap">
        <v-flex xs12 md3 class="pr-2 pb-1">
            <v-autocomplete
                rounded
                dense
                solo-inverted
                small
                outlined
                flat
                item-text="nome"
                label="Filtrar por funcionário"
                :items="getFuncionarios"
                v-model="getLogFiltros.funcionarioId"
                item-value="id"
                clearable
                hide-details
                @input="listarLogs"
            ></v-autocomplete>
        </v-flex>
        
        <v-flex xs12 md6 class="pr-2 pb-1">
            <v-text-field
                rounded
                dense
                solo-inverted
                outlined
                flat
                label="Filtrar por descrição"
                clearable
                v-model="getLogFiltros.descricao"
                @input="debounceSearch"
                hide-details
            ></v-text-field>
        </v-flex>

        <v-flex xs12 md3 class="pb-1 pr-1">
            <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="dates"
            transition="scale-transition"
            offset-y
            min-width="auto"
            >   
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        rounded
                        outlined
                        dense
                        solo-inverted
                        flat
                        hide-details=""
                        v-model="computedDate"
                        chips
                        color="grey darken-1"
                        small-chips
                        label="Filtrar por data"
                        @blur="getLogFiltros.data = this.$helper.formatDate(getLogFiltros.data)"
                        readonly
                        clearable
                        @input="listarLogs"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker
                    rounded
                    dense
                    solo-inverted
                    small
                    outlined
                    flat
                    label="Filtrar por data"
                    clearable
                    lang="pt-br"
                    type="date"
                    v-model="getLogFiltros.data"
                    @input="listarLogs"
                    hide-details
                >
                </v-date-picker>
            </v-menu>
        </v-flex>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
var _ = require('lodash')
export default {
    computed: {
        ...mapGetters([
            'getFuncionarios',
            'getLogFiltros'
        ]),
        computedDate: {
            get() {
                const data = this.$helper.formatDate(this.getLogFiltros.data)
                if(data === 'Invalid date') {
                    return ''
                } else {
                    return data
                }
            },
            set(value) {
                this.getLogFiltros.data = value
            }
        }
    },
    methods: {
        ...mapActions([
            'listarFuncionarios',
            'listarLogs'
        ]),
        debounceSearch() {
            const x = _.debounce(this.listarLogs, 800)
            x()
        }
    }
}
</script>